import React, { useState, useEffect } from "react";
import "./TaskEditor.css";

interface PromptDialogProps {
  title: string;
  label: string;
  placeholder?: string;
  defaultValue?: string;
  confirmText?: string;
  onConfirm: (value: string) => void;
  onCancel: () => void;
}

const PromptDialog: React.FC<PromptDialogProps> = ({
  title, label, placeholder, defaultValue, confirmText, onConfirm, onCancel,
}) => {
  const [value, setValue] = useState(defaultValue || "");

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onCancel();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onCancel]);

  function handleSubmit() {
    if (value.trim()) onConfirm(value.trim());
  }

  return (
    <div className="task-editor-overlay" onClick={onCancel}>
      <div className="task-editor" style={{ width: 420 }} onClick={(e) => e.stopPropagation()}>
        <div className="task-editor-header">
          <h2>{title}</h2>
          <button className="task-editor-close" onClick={onCancel}>&#x2715;</button>
        </div>
        <div className="task-editor-body">
          <div className="task-editor-field">
            <label>{label}</label>
            <input
              type="text"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter") handleSubmit(); }}
              placeholder={placeholder}
              autoFocus
            />
          </div>
        </div>
        <div className="task-editor-footer">
          <div className="task-editor-footer-left" />
          <div className="task-editor-footer-right">
            <button className="task-editor-btn task-editor-btn-cancel" onClick={onCancel}>
              Cancel
            </button>
            <button className="task-editor-btn task-editor-btn-save" onClick={handleSubmit}>
              {confirmText || "Create"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromptDialog;
